export const environment = {
  APP_ROOT: "https://dev.guestlist.heartland.us/",
  API_ROOT: "https://dev.guestlist.heartland.us/api",
  SOCKET_HOST: "https://dev.guestlist.heartland.us",
};



/** WEBPACK FOOTER **
 ** ./src/environments/environment.dev.js
 **/